import IpNavConfig from '../ip-configurations/IpNavConfig';
import CradlePointNavConfig from '../cradlePoint/CradlePointNavConfig';
import GtfsTestMonitoringAppConfig from '../agency-stop-configs/GtfsTestMonitoringAppConfig';

const agencyConfigurationModules = [CradlePointNavConfig, IpNavConfig, GtfsTestMonitoringAppConfig];

export default agencyConfigurationModules;



